import type { CreateOfferCargoFormSchemaType } from "@/pages/shipper-cargo-create/model/validation";
import {
  OFFER_CARGO_VEHICLE_SHAPES_LIST,
  VEHICLE_WEIGHT_CLASSES,
} from "@/shared/constants/offer-cargo";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { BaseSelect } from "@/shared/ui/base-select";
import { BaseTextField } from "@/shared/ui/base-text-field";
import {
  AccordionDetails,
  Box,
  FormControl,
  MenuItem,
  Stack,
} from "@mui/material";
import { type Control, Controller } from "react-hook-form";

export const VehicleForm = ({
  control,
}: {
  control: Control<CreateOfferCargoFormSchemaType>;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>車両</BaseAccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={3}>
          <BaseFormLabel label="トン数(車格)" isRequired>
            <Box display="flex" gap={1} sx={{ alignItems: "flex-end" }}>
              <Controller
                name="vehicleWeight"
                control={control}
                render={({ field, fieldState }) => (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="end"
                    minWidth={172}
                  >
                    <BaseSelect
                      {...field}
                      value={field.value}
                      type="number"
                      size="small"
                      sx={{ width: 192 }}
                      error={fieldState.invalid}
                      helperText={fieldState.error?.message}
                    >
                      {VEHICLE_WEIGHT_CLASSES.map((ton) => (
                        <MenuItem key={ton.value} value={ton.value}>
                          {ton.label}
                        </MenuItem>
                      ))}
                    </BaseSelect>
                  </Stack>
                )}
              />
            </Box>
          </BaseFormLabel>

          <BaseFormLabel
            label="ボディタイプ(車体の形状)"
            sx={{ maxWidth: "376px" }}
            isRequired
          >
            <Controller
              name="vehicleShape"
              control={control}
              render={({ field, fieldState }) => (
                <FormControl size="small" fullWidth error={fieldState.invalid}>
                  <BaseSelect
                    {...field}
                    value={field.value}
                    type="string"
                    sx={{ width: 192 }}
                    error={fieldState.invalid}
                    helperText={fieldState.error?.message}
                    onChange={(v) => {
                      field.onChange(v);
                    }}
                  >
                    {OFFER_CARGO_VEHICLE_SHAPES_LIST.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </BaseSelect>
                </FormControl>
              )}
            />
          </BaseFormLabel>
        </Box>
        <BaseFormLabel
          label="車両の条件(重量、形状、冷蔵設備の有無、装飾品など)"
          sx={{ mt: 3 }}
        >
          <Controller
            name="vehicleEquipmentMemo"
            control={control}
            render={({ field, fieldState }) => (
              <BaseTextField
                {...field}
                size="small"
                fullWidth
                sx={{
                  maxWidth: "376px",
                }}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                onChange={(value) => {
                  field.onChange(value);
                }}
              />
            )}
          />
        </BaseFormLabel>
      </AccordionDetails>
    </BaseAccordion>
  );
};
